import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_has_the_fac_failed_to_implement_select_a'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_has_the_fac_failed_to_implement_select_a',
  name: 'Which of the following has the facility failed to implement?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'COURT_ORDERS',
      text: 'Court orders',
      externalIds: [
        {
          id: 'wt-wor-4x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARBITRATION_AWARDS_',
      text: 'Arbitration awards\n',
      externalIds: [
        {
          id: 'wt-wor-5x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CONCILIATED_MEDIATED_AGREEMENTS',
      text: 'Conciliated/mediated agreements',
      externalIds: [
        {
          id: 'wt-wor-6x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SETTLEMENTS',
      text: 'Settlements',
      externalIds: [
        {
          id: 'wt-wor-7x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['COURT_ORDERS', 'ARBITRATION_AWARDS_', 'CONCILIATED_MEDIATED_AGREEMENTS', 'SETTLEMENTS'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-wor-3',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11640,
  sectionId: '2.2.5.5',
  impactArea: 'Harassment and Abuse',
  impactAreaId: 'HARRASSMENT_AND_ABUSE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
